import { getSocketOrigin } from '../services/api';

/** Presigned S3 displayUrl when present; otherwise resolve /uploads paths via backend origin. */
export function resolveGuideImageUrl(imageUrl, displayUrl) {
  if (displayUrl) return displayUrl;
  if (!imageUrl) return '';
  if (/^https?:\/\//i.test(imageUrl) || imageUrl.startsWith('blob:') || imageUrl.startsWith('data:')) {
    return imageUrl;
  }
  if (imageUrl.startsWith('/uploads/')) {
    const origin = getSocketOrigin();
    return `${origin}${imageUrl}`;
  }
  return imageUrl;
}

/** Resolve guide step video URL — prefer presigned display URL from API. */
export function resolveGuideVideoUrl(videoUrl, displayVideoUrl) {
  if (displayVideoUrl) return displayVideoUrl;
  return resolveGuideImageUrl(videoUrl, null);
}

export function videoMimeTypeFromUrl(url) {
  if (!url) return 'video/mp4';
  const path = String(url).split('?')[0].toLowerCase();
  if (path.endsWith('.webm')) return 'video/webm';
  if (path.endsWith('.mov')) return 'video/quicktime';
  if (path.endsWith('.ogg') || path.endsWith('.ogv')) return 'video/ogg';
  if (path.endsWith('.m4v')) return 'video/x-m4v';
  return 'video/mp4';
}
